import { Injectable } from '@angular/core';

export interface ApplicationsState {
    filters: { column: string; value: string }[];
    columnFilters: { [key: string]: string };
    page: number;
    pageSize: number;
    assignedByOM: boolean | null | 'showMyWork';
    showMyWork: boolean;
    assessmentstatus: string;
    strategyStatus: string;
    type: string;
    priority: string;
    showRejectedApps: boolean | null;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationsStateService {
    private state: ApplicationsState | null = null;

    save(state: ApplicationsState): void {
        this.state = { ...state, filters: [...state.filters], columnFilters: { ...state.columnFilters } };
    }

    restore(): ApplicationsState | null {
        return this.state;
    }

    clear(): void {
        this.state = null;
    }

    clearKeys(keys: (keyof ApplicationsState)[]): void {
        if (!this.state) return;
        keys.forEach(key => (this.state as any)[key] = null);
    }
}
